import React, { useState, useEffect, useCallback } from "react"
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
  Button,
  Form,
  FormFeedback,
  Spinner,
  Alert,
  FormGroup,
} from "reactstrap"
import { CKEditor } from "@ckeditor/ckeditor5-react"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
import Dropzone from "react-dropzone"
import { useHistory } from "react-router-dom"
import { toast } from "react-toastify"
import axios from "axios"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { URLS } from "../../Url"

const ProductEditForm = () => {
  const history = useHistory()
  const ProductId = sessionStorage.getItem("Productid")
  const [formData, setFormData] = useState({})
  const [errors, setErrors] = useState({})
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [thumbnailImages, setThumbnailImages] = useState([])
  const [description, setDescription] = useState("")

  const [highlights, setHighlights] = useState([])

  const [inputList, setInputList] = useState([
    { key: "", SpecificationaName: "" },
  ])
  const [Spec, setSpec] = useState([])

  const HandleSpecCheck = e => {
    setSpec(prev => ({
      ...prev,
      [e.target.name]: e.target.checked,
    }))
  }

  const [TaxCategory, setTaxCategory] = useState([])
  const [TaxSubCategory, setTaxSubCategory] = useState([])
  const [categories, setCategories] = useState([])
  const [Store, setStore] = useState([])
  const [subCategories, setSubCategories] = useState([])
  const [childCategories, setChildCategories] = useState([])
  const [isLoadingCategories, setIsLoadingCategories] = useState(false)

  const token = JSON.parse(localStorage.getItem("authUser"))?.token

  const fetchTaxCategory = useCallback(async () => {
    setIsLoadingCategories(true)
    try {
      const response = await axios.post(
        URLS.GetTaxCategory,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      )
      setTaxCategory(response.data.taxcategorys || [])
    } catch (error) {
      toast.error("Failed to load categories")
    }
  }, [token])

  const fetchCategories = useCallback(async () => {
    setIsLoadingCategories(true)
    try {
      const response = await axios.post(
        URLS.GetCategory,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      )
      setCategories(response.data.categorys || [])
    } catch (error) {
      toast.error("Failed to load categories")
    } finally {
      setIsLoadingCategories(false)
    }
  }, [token])

  const fetchStores = useCallback(async () => {
    try {
      const response = await axios.post(
        URLS.GetStore,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      )
      setStore(response?.data?.data[0]?._id || [])
    } catch (error) {
      toast.error("Failed to load stores")
    }
  }, [token])

  const handlechanges = e => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
    if (name === "categoryId") {
      fetchSubCategories(value)
    }
    if (name === "taxcategoryId") {
      fetchTaxSubCategories(value)
    }
  }

  const fetchTaxSubCategories = async data => {
    try {
      const response = await axios.post(
        URLS.GetTaxSubCategory,
        { taxcategoryId: data },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      setTaxSubCategory(response.data.taxsubcategorys || [])
      setFormData(prev => ({
        ...prev,
        taxsubcategoryId: "",
      }))
    } catch (error) {
      toast.error("Failed to load subcategories")
    }
  }

  const fetchSubCategories = async data => {
    try {
      const response = await axios.post(
        URLS.GetSubCategory,
        { categoryId: data },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      setSubCategories(response.data.data || [])
      setFormData(prev => ({
        ...prev,
        subcategoryId: "",
        childcategoryId: "",
      }))
    } catch (error) {
      toast.error("Failed to load subcategories")
    }
  }

  const handlechangess = e => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
    if (name === "subcategoryId") {
      fetchChildCategories(value)
    }
  }

  const fetchChildCategories = async data => {
    try {
      const response = await axios.post(
        URLS.GetChildCategories,
        { subcategoryId: data },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      setChildCategories(response.data.data || [])
      setFormData(prev => ({ ...prev, childcategoryId: "" }))
    } catch (error) {
      toast.error("Failed to load child categories")
    }
  }

  useEffect(() => {
    fetchCategories()
    fetchStores()
    fetchTaxCategory()
  }, [fetchCategories, fetchStores, fetchTaxCategory])

  const handleInputChange = e => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))

    // Clear error when field is edited
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: "" }))
    }
  }

  const handleSpecInputChange = (e, index) => {
    const { name, value } = e.target
    const list = [...inputList]
    list[index][name] = value
    setInputList(list)
  }

  const handleImageUpload = acceptedFiles => {
    if (acceptedFiles.length === 0) return

    const newImages = acceptedFiles.map(file => ({
      file,
      preview: URL.createObjectURL(file),
      name: file.name,
      size: file.size,
      formattedSize: formatFileSize(file.size),
    }))

    setThumbnailImages(prev => [...prev, ...newImages].slice(0, 5))
  }

  const removeImage = index => {
    setThumbnailImages(prev => {
      const newImages = [...prev]
      URL.revokeObjectURL(newImages[index]?.preview)
      newImages.splice(index, 1)
      return newImages
    })
  }

  const formatFileSize = bytes => {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"]
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2) + " " + sizes[i])
  }

  const HandleCheck = e => {
    const { name, checked } = e.target
    setHighlights(prev => ({
      ...prev,
      [name]: checked,
    }))
  }

  const handleRemoveClick = index => {
    const list = [...inputList]
    list.splice(index, 1)
    setInputList(list)
  }

  const handleAddClick = () => {
    setInputList([...inputList, { key: "", SpecificationaName: "" }])
  }

  const validateForm = () => {
    const newErrors = {}

    if (!formData.name) newErrors.name = "Product name is required"
    if (!formData.shortName) newErrors.shortName = "Short name is required"
    if (!formData.categoryId) newErrors.categoryId = "Category is required"
    if (!formData.price) newErrors.price = "Price is required"
    if (thumbnailImages.length === 0)
      newErrors.thumbnailImages = "At least one image is required"
    if (!description) newErrors.description = "Description is required"

    if (formData.price && isNaN(formData.price))
      newErrors.price = "Price must be a number"

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = async e => {
    e.preventDefault()

    if (!validateForm()) {
      toast.error("Please fix the errors in the form")
      return
    }

    setIsSubmitting(true)

    try {
      const formDataToSend = new FormData()
      formDataToSend.append("storeId", Store)
      formDataToSend.append("sku", formData.sku)
      formDataToSend.append("name", formData.name)
      formDataToSend.append("taxcategoryId", formData.taxcategoryId)
      formDataToSend.append("taxsubcategoryId", formData.taxsubcategoryId)
      formDataToSend.append("price", formData.price)
      formDataToSend.append("status", formData.status)
      formDataToSend.append("shortName", formData.shortName)
      formDataToSend.append("stock", formData.stock)
      formDataToSend.append("weight", formData.weight)
      formDataToSend.append("categoryId", formData.categoryId)
      formDataToSend.append("subcategoryId", formData.subcategoryId)
      formDataToSend.append("childcategoryId", formData.childcategoryId)
      formDataToSend.append("shortDescription", formData.shortDescription)
      formDataToSend.append("largeDescription", description)
      formDataToSend.append("highlight", JSON.stringify(highlights))
      formDataToSend.append("isspecification", Spec.isspecification)
      formDataToSend.append("specifications", JSON.stringify(inputList))

      thumbnailImages.forEach(image => {
        if (image.file) {
          formDataToSend.append("thumnailImage", image.file)
        } else if (typeof image === "string") {
          // Handle existing images (URL strings)
          formDataToSend.append("existingImages", image)
        }
      })

      const response = await axios.put(
        `${URLS.EditProduct}${ProductId}`,
        formDataToSend,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      )

      toast.success(response.data.message || "Product updated successfully")
      history.push("/products")
    } catch (error) {
      console.error("Error updating product:", error)
      toast.error(
        error.response?.data?.message ||
          "Failed to update product. Please try again."
      )
    } finally {
      setIsSubmitting(false)
    }
  }

  useEffect(() => {
    GetOneProductData()
  }, [])

  const GetOneProductData = () => {
    const data = {
      id: ProductId,
    }

    axios
      .post(URLS.GetOneProduct, data, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(res => {
        const productData = res?.data?.data || {}
        setFormData(productData)

        if (productData.taxcategoryId) {
          axios
            .post(
              URLS.GetTaxSubCategory,
              { taxcategoryId: productData.taxcategoryId },
              {
                headers: { Authorization: `Bearer ${token}` },
              }
            )
            .then(res => {
              setTaxSubCategory(res.data.taxsubcategorys || [])
            })
            .catch(error => {
              console.error("Error fetching subcategories:", error)
            })
        }

        if (productData.categoryId) {
          axios
            .post(
              URLS.GetSubCategory,
              { categoryId: productData.categoryId },
              {
                headers: { Authorization: `Bearer ${token}` },
              }
            )
            .then(res => {
              setSubCategories(res.data.data || [])
            })
            .catch(error => {
              console.error("Error fetching subcategories:", error)
            })
        }

        if (productData.subcategoryId) {
          axios
            .post(
              URLS.GetChildCategories,
              { subcategoryId: productData.subcategoryId },
              {
                headers: { Authorization: `Bearer ${token}` },
              }
            )
            .then(res => {
              setChildCategories(res.data.data || [])
            })
            .catch(error => {
              console.error("Error fetching child categories:", error)
            })
        }

        if (
          productData.specifications &&
          productData.specifications.length > 0
        ) {
          setInputList(productData.specifications)
        }

        setHighlights(
          productData.highlight?.[0] || {
            TopProduct: false,
            NewArrival: false,
            BestProduct: false,
            FeaturedProduct: false,
          }
        )

        setDescription(productData.largeDescription || "")

        if (productData.thumnailImage && productData.thumnailImage.length > 0) {
          setThumbnailImages(
            productData.thumnailImage.map(img => `${URLS.Base}${img}`)
          )
        }

        setSpec({
          isspecification: productData.isspecification || false,
        })
      })
      .catch(error => {
        console.error("Error fetching product data:", error)
        toast.error("Failed to load product data")
      })
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Product Management" breadcrumbItem="Edit Product" />

        <Row>
          <Col lg="12">
            <Card>
              <CardBody>
                <Form onSubmit={handleSubmit}>
                  <div className="mb-2">
                    <h5 className="mb-2 text-primary">Basic Information</h5>
                    <Row>
                      <Col md="4">
                        <FormGroup>
                          <Label>Product Name *</Label>
                          <Input
                            type="text"
                            name="name"
                            value={formData.name || ""}
                            onChange={handleInputChange}
                            invalid={!!errors.name}
                          />
                          <FormFeedback>{errors.name}</FormFeedback>
                        </FormGroup>
                      </Col>

                      <Col md="4">
                        <FormGroup>
                          <Label>Short Name *</Label>
                          <Input
                            type="text"
                            name="shortName"
                            value={formData.shortName || ""}
                            onChange={handleInputChange}
                            invalid={!!errors.shortName}
                          />
                          <FormFeedback>{errors.shortName}</FormFeedback>
                        </FormGroup>
                      </Col>

                      <Col md="4">
                        <FormGroup>
                          <Label>SKU </Label>
                          <Input
                            type="text"
                            name="sku"
                            value={formData.sku || ""}
                            onChange={handleInputChange}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>

                  <div className="mb-2">
                    <h5 className="mb-2 text-primary">Pricing</h5>

                    <Row>
                      <Col md="4">
                        <FormGroup>
                          <Label>Price *</Label>
                          <Input
                            type="number"
                            name="price"
                            value={formData.price || ""}
                            onChange={handleInputChange}
                            invalid={!!errors.price}
                          />
                          <FormFeedback>{errors.price}</FormFeedback>
                        </FormGroup>
                      </Col>

                      <Col md="4">
                        <FormGroup>
                          <Label>Quantity</Label>
                          <Input
                            type="number"
                            name="stock"
                            value={formData.stock || ""}
                            onChange={handleInputChange}
                            placeholder="Enter Quantity"
                          />
                        </FormGroup>
                      </Col>

                      <Col md="4">
                        <FormGroup>
                          <Label>Weight </Label>
                          <Input
                            type="number"
                            name="weight"
                            value={formData.weight || ""}
                            onChange={handleInputChange}
                            placeholder="Enter Weight"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>

                  <div className="mb-2">
                    <h5 className="mb-2 text-primary">Categories</h5>
                    <Row>
                      <Col md="4">
                        <FormGroup>
                          <Label>Category *</Label>
                          <Input
                            type="select"
                            name="categoryId"
                            value={formData.categoryId || ""}
                            onChange={handlechanges}
                            invalid={!!errors.categoryId}
                            disabled={isLoadingCategories}
                          >
                            <option value="">Select Category</option>
                            {categories.map(category => (
                              <option key={category._id} value={category._id}>
                                {category.name}
                              </option>
                            ))}
                          </Input>
                          <FormFeedback>{errors.categoryId}</FormFeedback>
                          {isLoadingCategories && (
                            <small className="text-muted">
                              Loading categories...
                            </small>
                          )}
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label>Subcategory</Label>
                          <Input
                            type="select"
                            name="subcategoryId"
                            value={formData.subcategoryId || ""}
                            onChange={handlechangess}
                          >
                            <option value="">Select Subcategory</option>
                            {subCategories.map(subCategory => (
                              <option
                                key={subCategory._id}
                                value={subCategory._id}
                              >
                                {subCategory.name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label>Child Category</Label>
                          <Input
                            type="select"
                            name="childcategoryId"
                            value={formData.childcategoryId || ""}
                            onChange={handleInputChange}
                          >
                            <option value="">Select Child Category</option>
                            {childCategories.map(childCategory => (
                              <option
                                key={childCategory._id}
                                value={childCategory._id}
                              >
                                {childCategory.name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                  <div>
                    <h5 className="mb-2 text-primary">Taxation </h5>
                    <Row>
                      <Col md="4">
                        <FormGroup>
                          <Label>Tax Category *</Label>
                          <Input
                            type="select"
                            name="taxcategoryId"
                            value={formData.taxcategoryId || ""}
                            onChange={handlechanges}
                          >
                            <option value="">Select Tax Category</option>
                            {TaxCategory.map(taxcategory => (
                              <option
                                key={taxcategory._id}
                                value={taxcategory._id}
                              >
                                {taxcategory.name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md="8">
                        <FormGroup>
                          <Label>Tax Sub Category *</Label>
                          <Input
                            type="select"
                            name="taxsubcategoryId"
                            value={formData.taxsubcategoryId || ""}
                            onChange={handlechanges}
                            disabled={!formData.taxcategoryId}
                          >
                            <option value="">Select Tax Sub Category</option>
                            {TaxSubCategory.map(taxsubcategory => (
                              <option
                                key={taxsubcategory._id}
                                value={taxsubcategory._id}
                              >
                                {taxsubcategory.name} / (
                                {taxsubcategory.tax_rate} %)
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                  <div className="mb-2">
                    <h5 className="mb-2 text-primary">Product Images</h5>
                    {errors.thumbnailImages && (
                      <Alert color="danger">{errors.thumbnailImages}</Alert>
                    )}
                    <Row>
                      <Col md="12">
                        <Dropzone
                          onDrop={handleImageUpload}
                          accept="image/*"
                          maxSize={5242880}
                          multiple
                        >
                          {({ getRootProps, getInputProps }) => (
                            <div
                              {...getRootProps()}
                              className="dropzone border rounded p-4 text-center"
                              style={{
                                borderStyle: "dashed",
                                cursor: "pointer",
                                backgroundColor: "#f8f9fa",
                              }}
                            >
                              <input {...getInputProps()} />
                              <div className="mb-2">
                                <i className="display-4 text-muted bx bxs-cloud-upload" />
                              </div>
                              <h5>
                                Drag and drop images here, or click to select
                              </h5>
                              <p className="text-muted">
                                Maximum 5 images (Max size: 5MB each)
                              </p>
                            </div>
                          )}
                        </Dropzone>
                      </Col>
                    </Row>

                    {thumbnailImages.length > 0 && (
                      <Row className="mt-3">
                        <Col md="12">
                          <h6 className="mb-2">Selected Images:</h6>
                          <div className="d-flex flex-wrap">
                            {thumbnailImages.map((image, index) => (
                              <div
                                key={index}
                                className="position-relative m-2"
                                style={{ width: "120px" }}
                              >
                                <img
                                  src={
                                    typeof image === "string"
                                      ? image
                                      : image.preview
                                  }
                                  alt={`Preview ${index + 1}`}
                                  className="img-thumbnail"
                                  style={{
                                    height: "120px",
                                    objectFit: "cover",
                                  }}
                                />
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm position-absolute top-0 end-0"
                                  style={{ transform: "translate(50%, -50%)" }}
                                  onClick={e => {
                                    e.stopPropagation()
                                    removeImage(index)
                                  }}
                                >
                                  <i className="bx bx-x" />
                                </button>
                                <div className="small text-truncate mt-1">
                                  {typeof image === "string"
                                    ? image.split("/").pop()
                                    : image.name}
                                </div>
                                <div className="small text-muted">
                                  {typeof image === "string"
                                    ? "Unknown size"
                                    : image.formattedSize}
                                </div>
                              </div>
                            ))}
                          </div>
                        </Col>
                      </Row>
                    )}
                  </div>

                  <div className="mb-2">
                    <h5 className="mb-2 text-primary">Descriptions</h5>

                    <Row>
                      <Col md="12">
                        <FormGroup>
                          <Label>Short Description *</Label>
                          <Input
                            type="textarea"
                            name="shortDescription"
                            value={formData.shortDescription || ""}
                            onChange={handleInputChange}
                            rows="4"
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col md="12">
                        <FormGroup>
                          <Label>Detailed Description *</Label>
                          {errors.description && (
                            <Alert color="danger" className="mb-2">
                              {errors.description}
                            </Alert>
                          )}
                          <CKEditor
                            editor={ClassicEditor}
                            data={description}
                            onChange={(event, editor) => {
                              setDescription(editor.getData())
                              if (errors.description) {
                                setErrors(prev => ({
                                  ...prev,
                                  description: "",
                                }))
                              }
                            }}
                            config={{
                              toolbar: [
                                "heading",
                                "|",
                                "bold",
                                "italic",
                                "link",
                                "bulletedList",
                                "numberedList",
                                "blockQuote",
                                "insertTable",
                                "undo",
                                "redo",
                              ],
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>

                  <div className="mb-2">
                    <h5 className="mb-2 text-primary">Product Highlights</h5>

                    <Row className="mt-3">
                      <Col md={2}>
                        <Label>Highlight :</Label>
                      </Col>

                      <Col md={12} className="d-flex pb-4">
                        <div className="form-check me-3 me-lg-5">
                          <Input
                            className="form-check-input"
                            type="checkbox"
                            name="TopProduct"
                            defaultChecked={highlights?.TopProduct}
                            value={highlights?.TopProduct}
                            onChange={HandleCheck}
                            id="TopProduct"
                            style={{ fontSize: "20px" }}
                          />
                          <Label
                            className="form-check-label pt-1"
                            htmlFor="TopProduct"
                          >
                            Top Product
                          </Label>
                        </div>

                        <div className="form-check me-lg-5">
                          <Input
                            className="form-check-input"
                            type="checkbox"
                            name="NewArrival"
                            defaultChecked={highlights?.NewArrival}
                            value={highlights?.NewArrival}
                            onChange={HandleCheck}
                            id="NewArrival"
                            style={{ fontSize: "20px" }}
                          />
                          <Label
                            className="form-check-label pt-1"
                            htmlFor="NewArrival"
                          >
                            New Arrival
                          </Label>
                        </div>

                        <div className="form-check me-3 me-lg-5">
                          <Input
                            className="form-check-input"
                            type="checkbox"
                            name="BestProduct"
                            onChange={HandleCheck}
                            defaultChecked={highlights?.BestProduct}
                            value={highlights?.BestProduct}
                            id="BestProduct"
                            style={{ fontSize: "20px" }}
                          />
                          <Label
                            className="form-check-label pt-1"
                            htmlFor="BestProduct"
                          >
                            Best Product
                          </Label>
                        </div>

                        <div className="form-check me-3 me-lg-5">
                          <Input
                            className="form-check-input"
                            type="checkbox"
                            name="FeaturedProduct"
                            defaultChecked={highlights?.FeaturedProduct}
                            value={highlights?.FeaturedProduct}
                            onChange={HandleCheck}
                            id="FeaturedProduct"
                            style={{ fontSize: "20px" }}
                          />
                          <Label
                            className="form-check-label pt-1"
                            htmlFor="FeaturedProduct"
                          >
                            Featured Product
                          </Label>
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <div className="mb-2">
                    <h5 className="mb-2 text-primary">Specifications</h5>

                    <Row>
                      <Col md="12">
                        <div className="d-flex align-items-center mb-2">
                          <div className="form-check form-switch me-3">
                            <Input
                              type="switch"
                              id="isspecification"
                              name="isspecification"
                              defaultChecked={Spec.isspecification}
                              value={Spec.isspecification}
                              onChange={HandleSpecCheck}
                              className="form-check-input"
                            />
                            <Label
                              htmlFor="isspecification"
                              className="form-check-label"
                            >
                              Enable Specifications
                            </Label>
                          </div>
                        </div>
                      </Col>
                    </Row>

                    {Spec.isspecification && (
                      <Col md={12}>
                        <div>
                          <Row>
                            {inputList.map((x, i) => (
                              <Row key={i}>
                                <div className="box row">
                                  <Col md="5" sm="12" className="mb-1">
                                    <Label>Key</Label>
                                    <Input
                                      type="text"
                                      required
                                      name="key"
                                      placeholder="Enter Key"
                                      value={x.key}
                                      onChange={e =>
                                        handleSpecInputChange(e, i)
                                      }
                                    />
                                  </Col>

                                  <Col md="5" sm="12" className="mb-1">
                                    <Label>Specification</Label>
                                    <Input
                                      type="text"
                                      required
                                      name="SpecificationaName"
                                      placeholder="Enter Specification"
                                      value={x.SpecificationaName}
                                      onChange={e =>
                                        handleSpecInputChange(e, i)
                                      }
                                    />
                                  </Col>

                                  <Col sm="2">
                                    <Label className="mt-1"></Label>
                                    <div className="btn-box">
                                      {inputList.length !== 1 && (
                                        <button
                                          className="mr10 btn btn-outline-danger btn-sm m-1 mt-3"
                                          type="button"
                                          onClick={() => handleRemoveClick(i)}
                                        >
                                          Remove
                                          <i className="bx bx-x-circle"></i>
                                        </button>
                                      )}
                                      {inputList.length - 1 === i && (
                                        <button
                                          className="btn btn-sm btn-outline-info m-1 mt-3"
                                          type="button"
                                          onClick={handleAddClick}
                                        >
                                          Add
                                          <i className="bx bx-plus-circle"></i>
                                        </button>
                                      )}
                                    </div>
                                  </Col>
                                </div>
                              </Row>
                            ))}
                          </Row>
                        </div>
                      </Col>
                    )}
                  </div>

                  <div className="d-flex justify-content-between mt-4">
                    <Button
                      color="primary"
                      onClick={() => history.goBack()}
                      disabled={isSubmitting}
                      size="sm"
                    >
                      <i className="bx bx-arrow-back me-1" /> Back
                    </Button>

                    <Button
                      color="primary"
                      type="submit"
                      disabled={isSubmitting}
                      size="sm"
                    >
                      {isSubmitting ? (
                        <>
                          <Spinner size="sm" className="me-2" />
                          Updating Product...
                        </>
                      ) : (
                        <>
                          <i className="fas fa-check-circle me-1" /> Update Product
                        </>
                      )}
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default ProductEditForm
